export default function Space({ height }) {
  return <div style={{ height }}></div>;
}
